/**
 * @file 模板
 */

import { FormulateDataType } from "./types"

const getAlgebra: () => FormulateDataType = () => ({
  key: 'algebra',
  data: [
    {
      label: '代数',
      items: [
        '\\left(x-1\\right)\\left(x+3\\right)',
        '\\sqrt{a^2+b^2}',
        '\\left ( \\frac{a}{b}\\right )^{n}= \\frac{a^{n}}{b^{n}}',
        '\\frac{a}{b}\\pm \\frac{c}{d}= \\frac{ad \\pm bc}{bd}',
        '\\frac{x^{2}}{a^{2}}-\\frac{y^{2}}{b^{2}}=1',
        '\\frac{1}{\\sqrt{a}}=\\frac{\\sqrt{a}}{a},a\\ge 0\\frac{1}{\\sqrt{a}}=\\frac{\\sqrt{a}}{a},a\\ge 0',
        'y-y_{1}=k \\left( x-x_{1}\\right)',
      ],
    },
  ],
})

const getGeometric: () => FormulateDataType = () => ({
  key: 'geometric',
  data: [
    {
      label: '几何',
      items: [
        '\\Delta A B C',
        'a \\parallel c,b \\parallel c \\Rightarrow a \\parallel b',
        'l \\perp \\beta ,l \\subset \\alpha \\Rightarrow \\alpha \\perp \\beta',
      ],
    },
  ],
})

const getInequality: () => FormulateDataType = () => ({
  key: 'inequality',
  data: [
    {
      label: '不等式',
      items: [
        'a > b,b > c \\Rightarrow a > c',
        '\\left | a-b \\right | \\geqslant \\left | a \\right | -\\left | b \\right |',
        '\\left | a+b \\right | \\leqslant \\left | a \\right | + \\left | b \\right |',
      ],
    },
  ],
})

const getTrig: () => FormulateDataType = () => ({
  key: 'trig',
  data: [
    {
      label: '三角函数',
      items: [
        'e^{i \\theta}',
        '\\left(\\frac{\\pi}{2}-\\theta \\right )',
        '\\text{sin}^{2}\\frac{\\alpha}{2}=\\frac{1- \\text{cos}\\alpha}{2}',
        '\\text{cos}^{2}\\frac{\\alpha}{2}=\\frac{1+ \\text{cos}\\alpha}{2}',
        '\\text{tan}\\frac{\\alpha}{2}=\\frac{\\text{sin}\\alpha}{1+ \\text{cos}\\alpha}',
        '\\sin \\alpha + \\sin \\beta =2 \\sin \\frac{\\alpha + \\beta}{2}\\cos \\frac{\\alpha - \\beta}{2}',
        '\\sin \\alpha - \\sin \\beta =2 \\cos \\frac{\\alpha + \\beta}{2}\\sin \\frac{\\alpha - \\beta}{2}',
        '\\cos \\alpha + \\cos \\beta =2 \\cos \\frac{\\alpha + \\beta}{2}\\cos \\frac{\\alpha - \\beta}{2}',
        '\\cos \\alpha - \\cos \\beta =-2\\sin \\frac{\\alpha + \\beta}{2}\\sin \\frac{\\alpha - \\beta}{2}',
        'a^{2}=b^{2}+c^{2}-2bc\\cos A',
        '\\frac{\\sin A}{a}=\\frac{\\sin B}{b}=\\frac{\\sin C}{c}=\\frac{1}{2R}',
        '\\sin \\left ( \\frac{\\pi}{2}-\\alpha \\right ) = \\cos \\alpha',
        '\\sin \\left ( \\frac{\\pi}{2}+\\alpha \\right ) = \\cos \\alpha',
      ],
    },
  ],
})

/**
 * 获取公式模板数据
 *
 * @returns 公式模板数据
 */
export const getTemplateData: () => FormulateDataType[] = () => [
  getAlgebra(),
  getGeometric(),
  getInequality(),
  getTrig(),
]
